import html2canvas from 'html2canvas';

const EXPORT_PX_WIDTH = 1600;
const A4_WIDTH_PT = 595.28;
const PAGE_PADDING_PT = 10;
const CONTENT_WIDTH_PT = A4_WIDTH_PT - PAGE_PADDING_PT * 2;
const A4_HEIGHT_PT = 841.89;
const CONTENT_HEIGHT_PT = A4_HEIGHT_PT - PAGE_PADDING_PT * 2;

async function captureNodeToCanvas(node) {
  const width = Math.ceil(node.getBoundingClientRect().width || 0);
  const canvas = await html2canvas(node, {
    backgroundColor: '#fff',
    useCORS: true,
    windowWidth: width,
    scale: 2,
    scrollY: -window.scrollY,
  });
  return canvas;
}

function sliceCanvasToPages(canvas) {
  const pxPerPt = canvas.width / CONTENT_WIDTH_PT;
  const pagePxHeight = Math.floor(CONTENT_HEIGHT_PT * pxPerPt);

  const slices = [];
  for (let y = 0; y < canvas.height; y += pagePxHeight) {
    const h = Math.min(pagePxHeight, canvas.height - y);
    const slice = document.createElement('canvas');
    slice.width = canvas.width;
    slice.height = h;
    const ctx = slice.getContext('2d');
    ctx.drawImage(canvas, 0, y, canvas.width, h, 0, 0, canvas.width, h);
    slices.push({
      src: slice.toDataURL('image/png'),
      width: slice.width,
      height: slice.height,
    });
  }
  return slices;
}

export {
  sliceCanvasToPages,
  captureNodeToCanvas,
  A4_WIDTH_PT,
  EXPORT_PX_WIDTH,
  PAGE_PADDING_PT,
  CONTENT_WIDTH_PT,
  A4_HEIGHT_PT,
  CONTENT_HEIGHT_PT,
};
